angular.
module("dx.webapp.examDuration").
controller("DxTimeLimitController", function TimeLimitController(
	$scope,

	DX_DURATION_SETTING,
	dxLocalize,
	dxConvertDuration
) {
	"use strict";

	var self = this;

	this.DX_DURATION_SETTING = DX_DURATION_SETTING;

	this.enabled = false;
	this.adjustable = true;
	this.hours = 1;
	this.minutes = 0;
	this.error = false;

	this.dropdownOptions = [
		{displayName: dxLocalize.get("ExamDuration.On"), value: true},
		{displayName: dxLocalize.get("ExamDuration.Off"), value: false},
	];

	this.$onInit = function onInit() {
		this.enabled = this.durationObject.durationSetting !== DX_DURATION_SETTING.OFF;

		if (this.enabled) {
			this.adjustable = this.durationObject.durationSetting === DX_DURATION_SETTING.ON_ADJUSTABLE;

			var time = dxConvertDuration.convertNsToTime(this.durationObject.duration);
			this.minutes = time.minutes;
			this.hours = time.hours;
		}

		isDurationValid();
	};

	// Force none undefined value in time fields.
	this.release = function release() {
		this.minutes = this.minutes || 0;
		this.hours = this.hours || 0;
	};

	$scope.$watch("vm.enabled", function watchEnabled(newValue, oldValue) {
		if (newValue !== oldValue) {
			if (self.enabled) {
				setAdjustable();
				setDuration();
			} else {
				self.durationObject.durationSetting = DX_DURATION_SETTING.OFF;
			}
		}
	});

	$scope.$watch("vm.adjustable", function watchAdjustable(newValue, oldValue) {
		if (newValue !== oldValue) {
			setAdjustable();
		}
	});

	$scope.$watch("vm.hours", function watchHours(newValue, oldValue) {
		// 9999 was chosen as it's the largest number that fit into the number box.
		if (self.hours > 9999) {
			self.hours = oldValue;
		}

		if (newValue !== oldValue) {
			setDuration();
		}
	});

	$scope.$watch("vm.minutes", function watchMinutes(newValue, oldValue) {
		if (self.minutes > 59) {
			self.minutes = oldValue;
		}

		if (newValue !== oldValue) {
			setDuration();
		}
	});

	function setDuration() {
		self.durationObject.duration = dxConvertDuration.convertTimeToNs(self.hours, self.minutes);
		isDurationValid();
	}

	function setAdjustable() {
		if (self.adjustable) {
			self.durationObject.durationSetting = DX_DURATION_SETTING.ON_ADJUSTABLE;
		} else {
			self.durationObject.durationSetting = DX_DURATION_SETTING.ON;
		}
	}

	function isDurationValid() {
		if (self.durationObject.duration === 0) {
			self.error = true;
			return false;
		}

		self.error = false;
		return true;
	}
});
